import classNames from 'classnames';
import React from 'react';
import { IButton } from './IButton';

const SecondarySquareBtn = (props: IButton) => {
  const { handleOnClick, children, width, disabled, hidden } = props;
  return (
    <button
      style={{ width: width || 'auto' }}
      className={classNames(
        '!h-fit rounded-md bg-white px-6 py-2 font-normal !leading-none text-primary ring-[1.5px] ring-primary transition-shadow ease-in hover:shadow-md',
        {
          'ring-border-color [&:disabled]:!bg-border-color/30 [&:disabled]:!ring-border-color/30': disabled,
        }
      )}
      onClick={handleOnClick}
      disabled={disabled}
      hidden={hidden}
    >
      {children}
    </button>
  );
};

export default SecondarySquareBtn;
